import { App, Plugin } from 'vue';

export interface DateUtil {
  $formatDate(value: Date): string | undefined;
}

export const DateUtil: Plugin = {
  install: (app: App) => {
    app.config.globalProperties.$formatDate = (value: Date) => {
      if (value == null || value == undefined || !(value instanceof Date))
        return;
      return `${value.getFullYear()}-${value.getMonth() + 1
        }-${value.getDate()}`;
    };
  },
};
